import { NgModule }                             from '@angular/core';
// Modules
import { SharedModule }                         from './../shared/shared.module';
import { DashboardRoutingModule }               from './dashboard-routing.module';
import { DragulaModule }                        from 'ng2-dragula/ng2-dragula';
// Directives
import { ProgramStatusDirective }               from './status.directive';
// Services
import { GroupService }                         from './program-list/group.service';
import { FieldManualService }                   from './program-list/field-manual.service';
import { GuideService }                         from './guides/guide.service';
import { CsvService }                           from './program-list/csv.service';
import { ImageService }                         from './program-list/image.service';
import { ProgramRoutesService }                 from './program-list/program/program-routes.service';
import { UserService }                          from './program-list/user.service';
import { JourneysService }                      from './journeys/journeys.service';
// Components
import { DashboardComponent }                   from './dashboard.component';
import { ProgramsComponent }                    from './program-list/programs/programs.component';
import { ProgramListComponent }                 from './program-list/program-list.component';
import { ProgramComponent }                     from './program-list/program/program.component';
import { SessionsComponent }                    from './program-list/sessions/sessions.component';
import { SessionComponent }                     from './program-list/sessions/session/session.component';
import { SessionUsersComponent }                from './program-list/sessions/session/session-users/session-users.component';
import { ProgramWithSessionsComponent }         from './program-list/program-with-sessions/program-with-sessions.component';
import { SessionTeamUsersComponent }            from './program-list/sessions/session/session-team-users/session-team-users.component';
import { EditFmReleasesComponent }              from './program-list/program/edit-fm-releases/edit-fm-releases.component';
import { EditSessionComponent }                 from './program-list/sessions/edit-session/edit-session.component';
import { TeamsListComponent }                   from './program-list/sessions/session/teams-list/teams-list.component';
import { FeaturedComponent }                    from './featured/featured.component';
import { GuidesComponent }                      from './guides/guides.component';
import { GuideComponent }                       from './guides/guide/guide.component';
import { JourneysComponent }                    from './journeys/journeys.component';
import { JourneyComponent }                     from './journeys/journey/journey.component';
import { FieldManualsComponent }                from './program-list/program/field-manuals/field-manuals.component';
import { GroupsComponent }                      from './program-list/program/groups/groups.component';
import { AnalyticsComponent }                   from './program-list/program/analytics/analytics.component';
import { GroupComponent }                       from './program-list/program/groups/group/group.component';
import { UsersComponent }                       from './program-list/program/groups/users/users.component';
import { ProgramSettingsComponent }             from './program-list/program/program-settings/program-settings.component';
import { AddUsersComponent }                    from './program-list/program/add-users/add-users.component';
import { RecentActivityComponent }              from './program-list/program/recent-activity/recent-activity.component';
import { AdminInputComponent }                  from './admin-input/admin-input.component';
import { BatchComponent }                       from './program-list/program/batch/batch.component';
import { BatchAddUsersToEditionComponent }      from './program-list/program/batch/batch-add-users-to-edition.component';
import { BatchAddUsersToSessionComponent }      from './program-list/program/batch/batch-add-users-to-session.component';
import { BatchAssignUsersTeamsComponent }       from './program-list/program/batch/batch-assign-users-teams.component';
import { GroupShellComponent }                  from './program-list/program/groups/group-shell/group-shell.component';
import { GroupSettingsComponent }               from './program-list/program/groups/group/group-settings/group-settings.component';
import { SubscriptionSettingsComponent }        from './program-list/subscription/subscription-settings.component'
import { GroupManageComponent }                 from './program-list/program/groups/group-manage/group-manage.component';
import { DeleteGroupConfirmComponent }          from './program-list/program/groups/delete-group-confirm/delete-group-confirm.component';
import { MoveGroupComponent }                   from './program-list/program/groups/move-group/move-group.component';
import { MoveUserToComponent }                  from './program-list/program/groups/users/move-user-to/move-user-to.component';
import { AddUsersToExistingTeamComponent }      from './program-list/program/groups/users/add-users-to-existing-team/add-users-to-existing-team.component';
import { UserSortPipe }                         from './program-list/program/groups/users/user-sort.pipe';
import { WaveDiffersWarningComponent }          from './program-list/program/groups/group/wave-differs-warning/wave-differs-warning.component';
import { GroupTableComponent }                  from './program-list/program/groups/group/group-table/group-table.component';
import { CustomDateTimeControlComponent }       from './program-list/program/groups/group/group-settings/custom-date-time-control/custom-date-time-control.component';
import { AddJourneyUsersComponent }             from './journeys/journey/add-journey-users/add-journey-users.component';
import { JourneyContentComponent }              from './journeys/journey/journey-content/journey-content.component';
import { EditJourneyDetailsComponent }          from './journeys/journey/edit-journey-details/edit-journey-details.component';
import { CloneJourneyComponent }                from './journeys/journey/clone-journey/clone-journey.component';
import { DashboardNavigationComponent }         from './dashboard-navigation/dashboard-navigation.component';
import { CheckForSimplifiedSessionManagement, CheckForSimplifiedSessionManagementChild }  from './guards';
import { AllUsersComponent }                    from './all-users/all-users.component';
import { SessionProgramRowComponent } from './program-list/sessions/session-program-row/session-program-row.component';

@NgModule({
  imports: [
    SharedModule,
    DashboardRoutingModule,
    DragulaModule,
  ],
  declarations: [
    TeamsListComponent,
    ProgramStatusDirective,
    DashboardComponent,
    ProgramListComponent,
    FeaturedComponent,
    GuidesComponent,
    ProgramComponent,
    SessionsComponent,
    SessionComponent,
    SessionUsersComponent,
    ProgramWithSessionsComponent,
    SessionTeamUsersComponent,
    EditFmReleasesComponent,
    EditSessionComponent,
    JourneysComponent,
    JourneyComponent,
    FieldManualsComponent,
    GroupsComponent,
    AnalyticsComponent,
    GroupComponent,
    UsersComponent,
    ProgramsComponent,
    GuideComponent,
    ProgramSettingsComponent,
    AddUsersComponent,
    RecentActivityComponent,
    AdminInputComponent,
    BatchComponent,
    BatchAddUsersToEditionComponent,
    BatchAddUsersToSessionComponent,
    BatchAssignUsersTeamsComponent,
    GroupShellComponent,
    GroupSettingsComponent,
    SubscriptionSettingsComponent,
    GroupManageComponent,
    DeleteGroupConfirmComponent,
    MoveGroupComponent,
    MoveUserToComponent,
    AddUsersToExistingTeamComponent,
    UserSortPipe,
    WaveDiffersWarningComponent,
    WaveDiffersWarningComponent,
    GroupTableComponent,
    CustomDateTimeControlComponent,
    JourneyContentComponent,
    AddJourneyUsersComponent,
    EditJourneyDetailsComponent,
    CloneJourneyComponent,
    DashboardNavigationComponent,
    AllUsersComponent,
    SessionProgramRowComponent,
  ],
  providers: [
    GroupService,
    FieldManualService,
    GuideService,
    CsvService,
    ImageService,
    UserService,
    JourneysService,
    ProgramRoutesService,
    CheckForSimplifiedSessionManagement,
    CheckForSimplifiedSessionManagementChild,
  ]
})

export class DashboardModule { }



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/dashboard/dashboard.module.ts